/**
 * Formatage partagé des données de saisie / journal DPI.
 * Extrait de DpiLivePage (US-VDPI-06) pour réutilisation /vocal (Phase 1 A3, DRY).
 */

export function formatValue(v: unknown): string {
  if (Array.isArray(v)) return v.map(formatValue).join(', ');
  if (typeof v === 'object' && v !== null) return JSON.stringify(v);
  return String(v);
}

export function summarizeData(data: Record<string, unknown>): string {
  const parts = Object.entries(data)
    .filter(([, v]) => v !== null && v !== undefined && v !== '')
    .map(([k, v]) => `${k}: ${formatValue(v)}`);
  return parts.length > 0 ? parts.join(' · ') : '(vide)';
}

export function formatTime(ts: string): string {
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return ts;
  return d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
}
